/**
 * Agents Feature Module
 * 
 * Encapsulates all agent-related components, services, and functionality.
 * This module can be easily enabled/disabled based on feature flags.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

// Agent Components
import { AgentSelectorComponent } from './components/agents-selector/agent-selector.component';
import { AgentLandingComponent } from './components/agent-landing/agent-landing.component';
import { AgentChatInterfaceComponent } from './components/agent-chat-interface/agent-chat-interface.component';
import { AgentChatContainerComponent } from './components/agent-chat-container/agent-chat-container.component';
import { AgentHeaderComponent } from './components/agent-header/agent-header.component';
import { AgentPillsComponent } from './components/agent-pills/agent-pills.component';
import { AgentHubComponent } from './components/agent-hub/agent-hub.component';
import { AgentShareChatViewerComponent } from './components/agent-share-chat-viewer/agent-share-chat-viewer.component';
import { AgentDocumentPreviewModalComponent } from './components/agent-document-preview-modal/agent-document-preview-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// Agent Workspace Components
import { AgentWorkspaceComponent } from './components/agent-workspace/agent-workspace.component';
import { AgentSelectorComponent as WorkspaceAgentSelectorComponent } from './components/agent-workspace/agent-selector/agent-selector.component';
import { AgentMainAreaComponent } from './components/agent-workspace/main-area/main-area.component';
import { AgentSourcePanelWrapperComponent } from './components/agent-source-panel-wrapper/agent-source-panel-wrapper.component';

// Agent Hub Shared Components
import { AgentCardComponent } from './shared/agent-card/agent-card.component';
import { CategoryBadgeComponent } from './shared/category-badge/category-badge.component';
import { FilterTabsComponent } from './shared/filter-tabs/filter-tabs.component';
import { SearchFilterComponent } from './shared/search-filter/search-filter.component';
import { AgentInfoPopupComponent } from './shared/agent-info-popup/agent-info-popup.component';

// Import SharedModule for shared components used by agents
import { SharedModule } from '../../shared/shared.module';
import { MetadataModule } from '../metadata/metadata.module';
import { SourcePanelModule } from '../components/source_panel/source-panel.module';
import { SourcePanelPipesModule } from '../pipes/source-panel-pipes.module';
import { NewsUpdatesModule } from '../components/news-updates/news-updates.module';

@NgModule({
  declarations: [
    // Agent Components
    AgentSelectorComponent,
    AgentLandingComponent,
    AgentChatInterfaceComponent,
    AgentChatContainerComponent,
    AgentHeaderComponent,
    AgentPillsComponent,
    AgentHubComponent,
    AgentShareChatViewerComponent,
    AgentDocumentPreviewModalComponent,
    
    // Agent Workspace Components
    AgentWorkspaceComponent,
    WorkspaceAgentSelectorComponent,
    AgentMainAreaComponent,
    AgentSourcePanelWrapperComponent,

    // Agent Hub Shared Components
    AgentCardComponent,
    CategoryBadgeComponent,
    FilterTabsComponent,
    SearchFilterComponent,
    AgentInfoPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    TranslateModule,
    SharedModule, // Import shared components for use in agent templates
    MetadataModule, // For app-chatbot-metadata (sources) in agent chat
    SourcePanelModule, // For app-source-panel in agent source panel wrapper
    SourcePanelPipesModule, // For refUrl and attachmentName pipes
    NewsUpdatesModule, // For app-news-updates component
    PdfViewerModule
  ],
  exports: [
    // Export agent components so they can be used in AppModule and routing
    AgentSelectorComponent,
    AgentLandingComponent,
    AgentChatInterfaceComponent,
    AgentChatContainerComponent,
    AgentHeaderComponent,
    AgentPillsComponent,
    AgentHubComponent,
    AgentShareChatViewerComponent,
    
    // Export agent workspace components
    AgentWorkspaceComponent,
    WorkspaceAgentSelectorComponent,
    AgentMainAreaComponent,
    
    // Export shared components for reuse in other modules
    AgentCardComponent,
    CategoryBadgeComponent,
    FilterTabsComponent,
    SearchFilterComponent,
    AgentInfoPopupComponent
  ],
  providers: []
})
export class AgentsModule { }

